export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553720247/About/metropalas.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553720394/About/Screen_Shot_2019-03-27_at_11.58.51_PM.png',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553720318/About/come004.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553720318/About/dinles002.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553720251/About/420-PM.png'
];